import * as Yup from 'yup';

export const RatingSchema = Yup.object().shape({
  rating: Yup.string().required('Please select your rating'),
  comments: Yup.string()
});

export interface RatingDataType {
  rating: number;
  comments?: string;
}

export const RatingInitialValues: RatingDataType =
{
  rating: 0,
  comments: '',
};

export interface RatingInterface {
  rating: number;
  comments?: string;
}
